import * as CrosstabUtils from '../util/CrosstabUtils';
import * as MMEUtils from '../util/MMEUtils';
import { VERTICAL_PERCENT_FILTER_VALUE } from '../constants';
import { ALL_ADULTS } from '../components/mme/MMEConstants';
import { ieSteps } from '../util/IEUtils';

export default {
  loginResponse: {},
  loginError: {},
  accounts: {
    preferredAccountId: null,
    accounts: null,
    activeAccountId: null,
    isTPAccount: false,
  },
  studies: {
    crosstabWeightTypes: {},
    quickreportsWeightTypes: {},
    datahaulWeightTypes: {},
    storiesWeightTypes: {},
    mmeWeightTypes: {},
    geoWeightTypes: {},
    datahubWeightTypes: {},
    weightTypeStudies: [],
  },
  userDetails: [],
  treeLoadNodesList: [],
  dictionaryTree: {},
  dictionaryTarget: {},
  dictionaryAnswerTarget: {},
  functionBox: {},
  geographiesTree: {},
  geographySmartSearch: {},
  definitionTree: {},
  definitionTarget: {},
  sharedList: {},
  smartView: false,
  activeAccountId: -1,
  crosstab: {
    trendComplete: false,
    openSharedCrossTab: [],
    BasesDataGridData: [],
    ColumnsDataGridData: [],
    RowsDataGridData: [],
    StandardBasesDataGridData: [],
    standardBaseLists: [],
    ddNHCSReportsList: [],
    allSelectedKPIsInfo: {},
    selectedKPIsTitle: {},
    activeCrosstabTable: {},
    sampleWeightedKPIs: {},
    loadedCrosstabInfo: {
      id: '',
      title: '',
      tableTitle: '',
      isDuplicateCrossTabTitle: false,
    },
    CrosstabBreadCrumbsList: {
      BasesGrid: {},
      ColumnsGrid: {},
      RowsGrid: {},
    },
    DictionaryDetails: {
      BasesGrid: {},
      ColumnsGrid: {},
      RowsGrid: {},
    },
    exportBaseSelectionList: {
      itemsLeft: [],
      itemsRight: [],
      universalStudy: false,
    },
    crosstabTitleHeaderList: {},
    isTitleUpdated: true,
    toggleCheckValue: {
      row: false,
      column: false,
    },
    crosstabColumnSort: {
      direction: CrosstabUtils.SORT_DIRECTION.ASC,
      variable: 'none',
    },
    probabilityFunctionList: [],
    partsToShow: {
      showCat: false,
      showSCats: false,
      showQ: true,
      showA: true,
    },
    useQuestions: true,
  },
  quickReports: {
    allSelectedQuickReportsKPIsInfo: {},
    selectedQuickReportsKPIsTitle: {},
    sampleWeightedQuickReportsKPIs: {},
    mapSettings: {
      indexGroupCount: 5,
    },
    quickReportRunFlag: true,
  },
  challengeQuestions: {},
  datahaulReports: [],
  storyboard: {},
  /*  demographics: {},
  attitudes: {},
  brands: {},
  media: {},
  insight360ReportsDictionaryTree: {},
  insights360Reports: {},
  personaCreator: {}, */
  insight360: {
    deepDivePopupShow: false,
    deepDiveDetails: {},
    demographics: [],
    insight360PersonaFilter: ['', '', ''],
    attitudes: [],
    insight360AttitudeAgreeChoice: '',
    insight360PersonaSample: [],
    insight360PersonaWeighted: [],
    insight360ReportsDictionaryTree: {},
    insights360Reports: [],
    insight360PersonaExpression: [],
    insight360PersonaExpressionID: [],
    insight360ExplorerDefId: [],
    insight360PersonaLabel: [],
    inight360VerticalPercent: VERTICAL_PERCENT_FILTER_VALUE,
    insights360ReportSortInfo: {},
    media: [],
    brands: [],
    profiles: [],
    profileBrands: [],
    profileMedia: [],
    selectedCategory: {},
    selectedFilters: {
      brands: [],
      media: [],
    },
    topMediaBrandSelectedFilters: {
      brands: [],
      media: [],
    },
    sortByIndexAndReach: {
      media: 'index',
      brands: 'index',
      profiles: 'index',
      attitudes: 'index',
      demographics: 'index',
    },
    definitionTree: [],
    insight360VariableSelection: [],
    insight360PersonaFixedHeaderChoice: false,
    error: {},
    bcConfiguration: {
      bcConfigPopupShow: { show: false },
    },
    excludesProfileAttList: [],
    personaCreator: {
      insight360AttitudeAgreeChoice: '',
      inight360VerticalPercent: VERTICAL_PERCENT_FILTER_VALUE,
      clusterSegments: {
        segmentCount: 3,
        attitudesList: [],
        clusterStatExpressions: [],
        selectedExpressionObject: [],
        defaultExpression: [],
        defaultExpressionObject: [],
        defaultAttitudinalTemplate: [],
        selectedAttitudinalTemplate: {},
      },
      sortByIndexAndReach: {
        media: 'index',
        brands: 'index',
        profiles: 'index',
        attitudes: 'index',
        demographics: 'index',
      },
      multiClusterSegments: [],
      segments: [],
      segmentsScreen: false,
      pcWelcomePopup: true,
      selectedFilters: {
        brands: [],
        media: [],
      },
      topMediaBrandSelectedFilters: {
        brands: [],
        media: [],
      },
    },
    bcSessionConfiguration: {},
  },
  dataPointsAlreadyAdded: false,
  selectedBase: {
    selectedBase: CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
    selectedBaseNode: CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
    selectedBaseGroup: CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
  },
  salesCatalyst: {
    salesCatalystBase: undefined,
    brandSelection: {
      audience: [],
      subAudience: [],
      competitors: [],
      market: [],
    },
    pitchSelection: {
      audience: [],
      subAudience: [],
      competitors: [],
      market: [],
    },
    selectedTemplates: {
      brand: {},
      pitch: {},
    },
    dataSelection: {
      targetMarket: [],
      entity: [],
      competitor: [],
      category: {},
      brand: [],
      targetEntityOverlap: {},
      subEntities: [],
    },
    dataOnScreen: {
      targetMarket: false,
      competition: false,
      mediaPackage: false,
    },
    graphData: {
      scTargetEntity: {},
      scTargetEntityBrand: {},
      scTarget: {},
      scTargetBrand: {},
      scBrands: {},
      scCompetitorsActivities: {},
      scCompetitors: {},
      scSubEntity: {},
      scCompetitorsComparison: [{}, {}, {}],
    },
    scAttitudesDisplayList: [],
    scDemoDisplayList: [],
    scMediaPackageInputFlag: true,
    chartSortInfo: {
      index: 0,
      type: 'desc',
      sortBy: 'Index',
    },
    scConfiguration: {
      configPopupShow: { show: false, defaultTab: undefined },
      package: {
        selectedList: undefined,
        appliedList: undefined,
        isListModified: false,
      },
    },
    scCompetition: {
      baseMarketSelectorVal: undefined,
      baseMarketSelectorValDefault: undefined,
      scatterplotDefaultCategory: undefined,
      selectedOptions: {
        strengthsListDefault: undefined,
        weaknessesListDefault: undefined,
        activitiesListDefaults: [undefined, undefined, undefined],
      },
    },
    scTarget: {
      selectedFilters: {
        brands: [],
        media: [],
      },
    },
    scSessionConfiguration: {},
    activitiesTemplateList: [],
  },
  university: false,
  lastCrosstabData: false,
  adminUsers: {},
  adminAccounts: {},
  preferences: {
    autoUpdateFlag: false,
    lastLocation: {},
    userPreferences: {},
    preferenceFlags: {
      crosstab: true,
      salesCatalyst: false,
      brandCatalyst: false,
    },
  },
  support: {
    navItems: [],
    docStudies: [],
    docInitialStudy: null,
  },
  mmeModule: {
    BasesDataGridData: [],
    TargetsDataGridData: [],
    StandardBasesDataGridData: [],
    allSelectedKPIsInfo: {},
    selectedKPIsTitle: {},
    activeMMETable: {},
    sampleWeightedKPIs: {},
    mmeTitleHeaderList: {},
    standardBaseLists: [],
    selectedBase: {
      selectedBase: MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE,
      selectedBaseNode: MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE,
      selectedBaseGroup: MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE,
    },
    selectedMediaVehicleIndex: 0,
    statementVariableSelected: ['0', '1'],
    mmeTableList: [],
    isEnableMMEViewer: false,
    reportType: 'SR',
    dimensionType: 0,
    mmeDefaultTargetList: [{ title: ALL_ADULTS, keyword: ALL_ADULTS }],
    mmeAllTargets: [],
    mmeAllTargetsTableList: {},
    landingTarget: 'ALL ADULTS',
    prevMMEVehicleCodes: [],
    prevMMEStatementVariables: [],
    prevMMEStatements: [],
    prevMMEReportType: '',
    prevMMEBase: '',
    runReportFlag: false,
  },
  geomap: {
    BaseDataGridData: [],
    TargetDataGridData: [],
    selectedReport: {},
    allSelectedGeoMapKPIsInfo: {},
    selectedGeoMapKPIsTitle: {},
    sampleWeightedGeoMapKPIs: {},
    originalTitles: {},
    geoMapTableList: [],
    selectedGeographicsTabIndex: 0,
    countyCategorySelectedVal: 'countyByMarket',
    zipcodeCategorySelectedVal: 'zipcodeByMarket',
    draggedParentNodes: {
      county: [],
      censusRegion: [],
      state: [],
      market: [],
      zipcode: [],
    },
    geographicsData: {
      countyByMarket: [],
      countyByState: [],
      censusRegion: [],
      state: [],
      market: [],
      zipcodeByMarket: [],
      zipcodeByState: [],
    },
    geographicsTableData: {
      censusRegion: [],
      state: [],
      market: [],
      county: [],
      zipcode: [],
    },
    geographicsTableApiQueues: {
      censusRegion: [],
      state: [],
      market: [],
      county: [],
      zipcode: [],
    },
    parentChildCountMap: {
      countyByMarket: {},
      countyByState: {},
      censusRegion: {},
      state: {},
      market: {},
      zipcodeByMarket: {},
      zipcodeByState: {},
    },
    allGeoNodesToCompare: {
      countyByMarket: [],
      countyByState: [],
      censusRegion: [],
      state: [],
      market: [],
      zipcodeByMarket: [],
      zipcodeByState: [],
    },
    geographicsSortOrder: {
      county: {},
      censusRegion: {},
      state: {},
      market: {},
      zipcode: {},
    },
    geographicsCount: {
      countyByMarket: 0,
      countyByState: 0,
      censusRegion: 0,
      state: 0,
      market: 0,
      zipcodeByMarket: 0,
      zipcodeByState: 0,
    },
    expApiQueue: [],
    exportSpinnerProgressFlag: false,
    exportSpinnerWarningInfoMsg: false,
    mapSettings: {
      censusRegion: {
        exclude: false,
        indexGroupCount: 5,
        geoLabel: false,
        indexLabel: false,
      },
      state: {
        exclude: false,
        indexGroupCount: 5,
        geoLabel: false,
        indexLabel: false,
      },
      market: {
        exclude: false,
        indexGroupCount: 5,
        geoLabel: false,
        indexLabel: false,
      },
      county: {
        exclude: false,
        indexGroupCount: 5,
        geoLabel: false,
        indexLabel: false,
      },
      zipcode: {
        exclude: false,
        indexGroupCount: 5,
        geoLabel: false,
        indexLabel: false,
      },
    },
    isGeoMapTableDataLoading: false,
  },
  turnkeyOmnibus: {
    activeStep: ieSteps.SURVEY_LIST,
    navFlow: false,
    ieStudy: {
      loading: true,
      error: false,
      data: [],
    },
    ieSurveyList: {
      loading: false,
      error: false,
      data: [],
    },
    surveyDetails: {
      data: null,
    },
    ieCategories: {
      loading: false,
      error: false,
      data: [],
    },
    isEdit: false,
    ieSurvey: {
      loading: false,
      error: false,
      data: null,
    },
    selectedTargets: [],
    completesEstimate: null,
    samplewgtd: null,
    crossTabIR: null,
    surveyInfo: {
      surveyId: null,
      surveyName: '',
      categoryId: null,
      categoryName: '',
      expression: '',
      targetingCriteria: '',
      feasibilityExpression: [],
      study: {
        pn: null,
        sti: null,
        sd: '',
        wt: null,
        dv: null,
        st: '',
      },
      requiredCompletes: 2000,
      incidenceRate: 100,
      estimatedCost: 15000,
      gizmoSurveyId: null,
      prodegeProjectId: null,
      noOfQuestions: 0,
    },
    prodegeKeywords: null,
    keywords: [],
    targetingCriteria: {
      loading: true,
      error: false,
      sti: null,
      data: [],
    },
    savingSurvey: {
      loading: false,
      error: false,
    },
    ir_ss_data: {
      loading: true,
      error: false,
    },
    surveyQnO: {
      loading: true,
      error: false,
      metaData: [],
      data: {
        questions: [],
        options: [],
      },
      invalid: {
        specialChar: [],
        maxLength: [],
      },
      dictionary: null,
      updatedQnO: {
        questions: [],
        options: [],
      },
    },
  },
  correspondenceCluster: {
    projects: [],
    projectId: null,
    activeProjectId: null,
  },
  deTargetDashboard: {
    definition: {
      loading: true,
      error: false,
      response: {
        totalPages: 1,
        currentPage: 1,
        hasMorePages: false,
        data: [],
      },
      hasDefinition: false,
      query: {
        searchText: '',
        sortBy: 'updts',
        sortOrder: 'desc',
        pageNo: 1,
      },
    },
  },
  deImportDefiniton: {
    studies: {
      defaultStudy: null,
      activeStudy: null,
      isLatestStudy: true,
      loading: true,
      error: false,
      data: [],
    },
    studyDefinition: {
      activeStudy: null,
      studyTargets: {
        loading: true,
        error: false,
        data: [],
      },
      available: null,
      selected: {
        data: [],
        importValidations: {},
        hasSuccess: 0,
      },
      imports: [],
    },
    isEditTargetDefinition: false,
    isImportClicked: false,
  },
  deLabel: {
    loading: true,
    selectedTargets: null,
    targetExpression: [],
  },

  middleData: [],
  entStudies: [],
  selectedLocations: [],
  contractAdmin: {
    hasEntChanged: false,
    addNewFlag: false,
    addNewEntitlement: false,
    isSummary: false,
    editEntitlement: false,
    navItems: [],
    definition: {
      loading: true,
      error: false,
      response: {
        totalPages: 1,
        currentPage: 1,
        hasMorePages: false,
        data: [],
      },
      hasDefinition: false,
      query: {
        searchPhrase: '',
        searchBy: 'account',
        pageNumber: 1,
        pageSize: 10,
        sortColumn: 'account_accountName',
        sortOrder: 'desc',
      },
    },
    selectedContractId: '',
    selectedLocationId: '',
    addAccount: {
      accountId: '',
      accountName: '',
      accountType: 'STANDARD',
      industryTypeDesc: '',
      activeStatus: 'Y',
      accountLinkType: 'No Link',
      parentAccountId: null,
      contracts: [
        {
          accessedBasedOn: 'NATIONALSTUDY',
          universityBackData: '',
          univIpAddresses: [''],
          contractNumber: '',
          lastNationalStudy: '',
          optInDate: '',
          studyStart: '',
          studyEnd: '',
          optOutDate: '',
          contractName: '',
          status: 'A',
          statusDate: '',
          contractStart: '',
          contractEnd: '',
          documents: '',
          documentId: '',
          notes: '',
          address: {
            zipCode: '',
            phone: '',
            internalContact: '',
            country: '',
            state: '',
            streetAddress: '',
            apt: '',
            city: '',
          },
          // contacts: []
        },
      ],
      locations: [],
      // locations: [{
      //   locationName: "",
      //   companyName: "",
      //   city: "",
      //   state: "",
      //   contactEmail: "",
      //   contactName: ""
      // }],
      id: '',
    },
    editedAccountData: {
      accountId: '',
      accountName: '',
      accountType: 'STANDARD',
      industryTypeDesc: '',
      activeStatus: 'Y',
      accountLinkType: 'No Link',
      parentAccountId: null,
      contracts: [
        {
          accessedBasedOn: 'NATIONALSTUDY',
          univIpAddresses: [''],
          universityBackData: '',
          lastNationalStudy: '',
          optInDate: '',
          studyStart: '',
          studyEnd: '',
          optOutDate: '',
          contractNumber: '',
          contractName: '',
          status: 'A',
          statusDate: '',
          contractStart: '',
          contractEnd: '',
          documents: '',
          notes: '',
          documentId: '',
          address: {
            zipCode: '',
            phone: '',
            internalContact: '',
            country: '',
            state: '',
            streetAddress: '',
            apt: '',
            city: '',
          },
          // contacts: []
        },
      ],
      locations: [],

      id: '',
    },

    middleData: [],
    entStudies: [],
    selectedLocations: [],
    locations: [],
    mriTopMarkets: [],
    simmonsLocalMarkets: [],
    memriUsers: [],
    editEntMarkets: [],
    editEntMemri: [],
    propCodes: [],
    editSelectedPropCode: [],
    editSelectedMRIMarket: [],
    editSelectedMEMRIUser: [],
    propCodeTypes: [],
  },
  deDistribute: {
    askForUnsavedChanges: false,
    isDistributeModalOpen: false,
    distributeData: {
      isLoading: true,
      isError: false,
      data: [],
    },
    updatedCampaign: null,
    selectedTarget: null,
    destinations: {
      isLoading: true,
      isError: false,
      data: [],
    },
    distErrors: {
      isNameErr: false,
      isNameErrMsg: '',
      isDateErr: false,
      isDateErrMsg: '',
      isTargetErr: false,
      isTargetErrMsg: '',
    },
    tempDistRequest: null,
    tempSelectedTarget: null,
    distRequest: {
      name: '',
      isForActivation: true,
      startDate: null,
      endDate: null,
      status: '',
      requestId: '',
      dest: [],
      jiraId: '',
    },
    isDeleteRequest: false,
    isDeleteRequestId: null,
    isDeleteRequestName: '',
    isConfirmRequest: false,
  },
  deBuild: {
    tempTarget: null,
    editTarget: null,
    DictionaryDetails: {
      TargetGrid: {},
    },
    addTargetAPIFlag: false,
    deAutocodeTargetEdit: false,
    deAutocodeTargetEditData: undefined,
    deBuildTargets: [],
    successDeBuildTargets: [],
    partsToShow: {
      showCat: false,
      showSCats: false,
      showQ: true,
      showA: true,
    },
    errorSelectionBox: false,
    isSaveTargetClicked: false,
    isEditTarget: false,
  },
  rldTool: {
    study: {
      studies: [],
      selectedStudy: {},
    },
    dictionary: {
      dictionaryTree: [],
      dictionaryTarget: [],
    },
    account: {
      accounts: [],
      selectedAccount: {},
    },
    columnSeperator: 1,
    dictionaryFileFormat: 2,
    fileStructureFormat: 1,
    email: [],
    enableGenerateFile: false,
    successMessage: false,
    isDictionaryOnly: false,
    isAllLocalMarkets: false,
    currentView: 'LIBRARY',
    rldList: [],
  },
};
